import { emptyApi } from "./emptyApi";

// Types for the API response
export interface BookkeepingQuoteResponse {
  no_of_transactions: number;
  cash_expense: number;
  intra_group_transfers: number;
  intra_company_transfers: number;
  monthly_billable_expenses_volume: number;
}

export const bookkeepingQuoteApis = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getBookkeepingQuote: build.query<
      BookkeepingQuoteResponse,
      {
        entity_id: string;
        from_date: string;
        to_date: string;
      }
    >({
      query: ({ entity_id, from_date, to_date }) => ({
        url: `/api/inkle/bookkeeping/entity/${entity_id}/months_quote/`,
        params: {
          from_date,
          to_date,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetBookkeepingQuoteQuery } = bookkeepingQuoteApis;
